// extracted by mini-css-extract-plugin
export default {"title":"MyExams_title__KVLuC","ButtonWrapper":"MyExams_ButtonWrapper__99Eeh","DivContainer":"MyExams_DivContainer__cmjBt","ResultsDiv":"MyExams_ResultsDiv__bZ3Ht"};